import {useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import {getIpRanges, saveIpRanges} from 'src/openapi/admin/apis/IpControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import {getAccountId} from '../../../../services/selectors';
import {rangesSelector} from '../services/selectors';

import type {RangesListDto} from '../typedef';

export const useRanges = () => {
    const apiDispatch = useAppDispatch();
    const accountId: number = useSelector(getAccountId);
    const ranges = useSelector(rangesSelector);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (!ranges && accountId) {
            apiDispatch(getIpRanges({accountId}));
        }
    }, [accountId, ranges, apiDispatch]);

    const onUpdateRanges = useCallback(async (rangesList: RangesListDto) => {
        setBusy(true);

        await apiDispatch(saveIpRanges({accountId, apiIpRange: rangesList}));
        await apiDispatch(getIpRanges({accountId}));

        setBusy(false);
    }, [accountId, apiDispatch]);

    return ({
        ranges,
        onUpdateRanges,
        busy,
    });
};
